// Sends a conversion event to GA4 and Bing UET (phone clicks also go to Reddit
// as a custom PhoneCall event). When `onceKey` is given, the
// event fires at most once per key per browser session (sessionStorage flag).
// If sessionStorage is unavailable the event still fires.
export function trackEvent(name, value, onceKey) {
  if (typeof window === "undefined") return;

  if (onceKey) {
    const flag = `tracked:${name}:${onceKey}`;
    try {
      if (window.sessionStorage.getItem(flag)) return;
      window.sessionStorage.setItem(flag, "1");
    } catch {}
  }

  if (typeof window.gtag === "function") {
    window.gtag("event", name, { currency: "USD", value });
  }
  if (typeof window.uetq?.push === "function") {
    window.uetq.push("event", name, { revenue_value: value, currency: "USD" });
  }
  if (name === "phone_number" && typeof window.rdt === "function") {
    window.rdt("track", "Custom", { customEventName: "PhoneCall", value, currency: "USD" });
  }
}
